'use client';
import styled from 'styled-components';

export const StyledLoginContainer = styled.main`
  min-height: 100vh;
  background: ${props => props.theme.colors.background.base};
`;
